import Reveal from "./Reveal";
import { STEPS } from "../data/site";

export default function Strip() {
  return (
    <section data-testid="strip-ringkas" className="border-y border-emerald/15 bg-forest">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-5 py-10 sm:px-8 md:grid-cols-3 md:gap-0">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.08} className={i > 0 ? "md:border-l md:border-emerald/20 md:pl-10" : ""}>
            <div className="text-center">
              <p className="text-lg font-black text-goldlight">{s.num} —</p>
              <p className="mt-1 text-sm font-light text-cream md:text-base">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
